module.exports = __webpack_public_path__ + "static/know-more-718a63cb84702f1ae721822f34302914.jpg";